import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import OneInchIcon from '../Icons/OneInchIcon';
import CoinGeckoIcon from '../Icons/CoinGecko';

import './TokenTokenLists.scss';
import PancakeswapIcon from '../Icons/PancakeswapIcon';

const TokenTokenLists = ({ lists = [] }) => (
  <div className="token-token-lists-wrapper">
    {lists.map((listName) => {
      const Icon = useMemo(() => {
        switch (listName) {
          case '1inch':
            return OneInchIcon;

          case 'coingecko':
            return CoinGeckoIcon;
          case 'pancakeswap':
            return PancakeswapIcon;

          default:
            return () => <></>;
        }
      }, [listName]);

      return <Icon key={listName} />;
    })}
  </div>
);

TokenTokenLists.propTypes = {
  lists: PropTypes.array.isRequired,
};

export default TokenTokenLists;
